"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "5 5 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M22.2188 9H9.5L9.21875 7.625C9.15625 7.28125 8.84375 7 8.5 7H5.375C5.15625 7 5 7.1875 5 7.375V8.125C5 8.34375 5.15625 8.5 5.375 8.5H7.875L10.0312 19.625C9.6875 20 9.5 20.4688 9.5 21C9.5 22.125 10.375 23 11.5 23C12.5938 23 13.5 22.125 13.5 21C13.5 20.7188 13.375 20.2812 13.2188 20H17.75C17.5938 20.2812 17.5 20.7188 17.5 21C17.5 22.125 18.375 23 19.5 23C20.5938 23 21.5 22.125 21.5 21C21.5 20.4375 21.25 19.9375 20.875 19.5625L20.9062 19.4375C21 18.9688 20.6562 18.5 20.1562 18.5H11.3438L11.0625 17H20.8125C21.1875 17 21.4688 16.7812 21.5625 16.4375L22.9688 9.9375C23.0625 9.46875 22.7188 9 22.2188 9ZM19.5 20.25C19.9062 20.25 20.25 20.5938 20.25 21C20.25 21.4375 19.9062 21.75 19.5 21.75C19.0625 21.75 18.75 21.4375 18.75 21C18.75 20.5938 19.0625 20.25 19.5 20.25ZM11.5 20.25C11.9062 20.25 12.25 20.5938 12.25 21C12.25 21.4375 11.9062 21.75 11.5 21.75C11.0625 21.75 10.75 21.4375 10.75 21C10.75 20.5938 11.0625 20.25 11.5 20.25ZM20.2188 15.5H10.75L9.78125 10.5H21.3125L20.2188 15.5ZM13.5 13.25C13.5 13.4688 13.6562 13.625 13.875 13.625H14.875V14.625C14.875 14.8438 15.0312 15 15.25 15H15.75C15.9375 15 16.125 14.8438 16.125 14.625V13.625H17.125C17.3125 13.625 17.5 13.4688 17.5 13.25V12.75C17.5 12.5625 17.3125 12.375 17.125 12.375H16.125V11.375C16.125 11.1875 15.9375 11 15.75 11H15.25C15.0312 11 14.875 11.1875 14.875 11.375V12.375H13.875C13.6562 12.375 13.5 12.5625 13.5 12.75V13.25Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;